
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portafolio",
      function () {
        return require("private-next-pages/portafolio.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/portafolio"])
      });
    }
  